import { Record, Map, List } from "immutable";
import { AnyAction } from "redux";

import { LOADING_STATE } from "@typings/reduxThunkActions";

import {
  ACTION_FAIL,
  ACTION_SUCCESS,
} from "@services/AsyncActionCreatorFactory";

import {
  UPDATE_PETS,
  FETCH_LOCATIONS,
  FETCH_B2B_LOCATIONS,
  SET_FROM_LOCAL_STORAGE,
  FETCH_ZIP_CODES_SUGGESTIONS,
  SET_ZIP_CODES_SUGGESTIONS,
} from "./locations.actions";
import { LocationsReducer } from "./locations.typings";
import {
  locationsFactory,
  b2bLocationsFactory,
  zipSuggestionsFactory,
} from "./locations.factories";

const initialState = Record<LocationsReducer>({
  defaultLocationId: "",
  invoiceLocationId: "",
  legalLocationId: "",
  locations: Map(),
  b2bLocations: Map(),
  zipSuggestions: List(),
  loadingState: LOADING_STATE.IDLE,
  b2bLoadingState: LOADING_STATE.IDLE,
});

const locationsReducer = (
  store: Record<LocationsReducer> = initialState(),
  action: AnyAction,
): Record<LocationsReducer> => {
  const { payload, type, params } = action;

  switch (type) {
    case SET_FROM_LOCAL_STORAGE: {
      return action.payload || store;
    }

    case FETCH_LOCATIONS: {
      return store.set("loadingState", LOADING_STATE.LOADING);
    }

    case `${FETCH_LOCATIONS}${ACTION_SUCCESS}`: {
      const { data } = payload;

      return store
        .merge(locationsFactory(data, store))
        .set("loadingState", LOADING_STATE.SUCCEEDED);
    }

    case `${FETCH_LOCATIONS}${ACTION_FAIL}`: {
      return store.set("loadingState", LOADING_STATE.FAILED);
    }

    case FETCH_B2B_LOCATIONS: {
      return store.set("b2bLoadingState", LOADING_STATE.LOADING);
    }

    case `${FETCH_B2B_LOCATIONS}${ACTION_SUCCESS}`: {
      const { data } = payload;

      return store
        .mergeIn(["b2bLocations"], b2bLocationsFactory(data))
        .set("b2bLoadingState", LOADING_STATE.SUCCEEDED);
    }

    case `${FETCH_B2B_LOCATIONS}${ACTION_FAIL}`: {
      return store.set("b2bLoadingState", LOADING_STATE.FAILED);
    }

    case `${UPDATE_PETS}${ACTION_SUCCESS}`: {
      const { id, hasPets } = params;
      return store.setIn(["locations", id, "hasPets"], hasPets);
    }

    case `${FETCH_ZIP_CODES_SUGGESTIONS}${ACTION_SUCCESS}`: {
      const { data } = payload;

      return store.set("zipSuggestions", zipSuggestionsFactory(data));
    }

    case `${SET_ZIP_CODES_SUGGESTIONS}`: {
      return store.set("zipSuggestions", payload);
    }

    default: {
      return store;
    }
  }
};

export { locationsReducer };
